export default __webpack_public_path__ + "static/media/Web 1280 ΓÇô 14.876fcf50.jpg";